<style scoped lang="less">
.banner {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
        width: 40px;
    }
    .long {
        width: 130px;
        height: 130px;
    }
}
</style>

<template>
    <div class="yb-container">
        <div class="line-container">
            <el-button size="mini" type="success" @click.stop="addOrEdit(null)">新增</el-button>
        </div>

        <paged-table class="block-mini-top" ref="table" @fetch-data="fetchData">
            <el-table slot :data="data" border size="mini" :cell-style="$parent.$parent.cellStyle">
                <el-table-column label="图标" align="center" width="60">
                    <template slot-scope="scope" v-if="scope.row.cover">
                        <div class="banner">
                            <img :src="scope.row.cover">
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="标题" prop="title" align="center" width="100"></el-table-column>
                <el-table-column label="跳转类型" prop="toType" align="center" width="100"></el-table-column>
                <el-table-column label="跳转详情" align="center" width="300">
                    <template slot-scope="scope">
                        <template v-if="scope.row.toType=='商品'">
                            <div>{{scope.row.toGood.category}} · {{scope.row.toGood.title}}</div>
                            <div>预计年化：{{scope.row.toGood.expectRate}}&nbsp;&nbsp;&nbsp;&nbsp;起投：{{scope.row.toGood.startAmount}}</div>
                        </template>
                        <template v-else-if="scope.row.toType=='长图'">
                            <div>自定义跳转标题：{{scope.row.toTitle}}</div>
                            <div class="banner">
                                <img class="long" :src="scope.row.toImageUrl">
                            </div>
                        </template>
                        <template v-else-if="scope.row.toType=='商品列表'">
                            <div>自定义跳转标题：{{scope.row.toTitle}}</div>
                            <div>筛选商品类型：{{scope.row.toGoodList}}</div>
                        </template>
                        <template v-else-if="scope.row.toType=='无跳转'">
                            <div>/</div>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="上架" align="center" width="60">
                    <template slot-scope="scope">
                        <el-switch @change="doOnline(scope.row)" :width="35" v-model="scope.row.online">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="备注" align="center" width="200">
                    <template slot-scope="scope">
                        {{scope.row.remarks}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" class="super-mini-button" @click.stop="addOrEdit(scope.row)">编辑</el-button>
                        <el-button type="danger" size="mini" class="super-mini-button" @click.stop="removeModel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </paged-table>
        <dialog-edit-icon ref="edit" @fetch-data="fetchData"></dialog-edit-icon>
    </div>
</template>

<script>
import PagedTable from "../components/PagedTable.vue";
import { HttpClient } from "../util/http";
import { actionConfirm, msgError, msgSuccess } from "../util/toast";
import { removeModel } from "../util/restful";
import DialogEditIcon from "../components/dialog/dialogEditIcon.vue";

export default {
    components: {
        PagedTable,
        DialogEditIcon,
    },
    mixins: [],
    data() {
        return {
            data: [],
            keyword: "",
            loading: false,
        };
    },
    created() {},
    mounted() {},
    computed: {
        table() {
            return this.$refs.table;
        },
        edit() {
            return this.$refs.edit;
        },
    },
    mounted() {},
    methods: {
        async doOnline(item) {
            this.loading = true;
            await HttpClient.put("/restful", {
                model: "Banner",
                cond: item._id,
                updates: item,
            });
            msgSuccess();
            this.refetchData();
        },
        refetchData() {
            this.table.refetchData();
        },
        async fetchData() {
            let cond = {
                type: "图标",
            };
            this.loading = true;
            let res = await HttpClient.post("/restful", {
                model: "Banner",
                cond,
                populate: "toGood",
                pageSize: this.table.pageSize,
                pageNum: this.table.pageNum,
                withCount: true,
            });
            this.data = res.result;
            this.table.submitTotal(res.count);
            this.loading = false;
        },
        addOrEdit(item) {
            this.edit.addOrEdit(item);
        },
        async removeModel(item) {
            await actionConfirm();
            this.loading = true;
            await removeModel("Banner", item._id);
            msgSuccess();
            this.refetchData();
        },
    },
};
</script>
